import { observer } from 'mobx-react';
import { useDataProvider } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../providers/ServiceProviderProvider';
import SkillsSetup from '../../components/SkillsSetup';
import getConfig from '../../configs/sp-config';
import ServiceProviderLayout from '../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../utils/getSPLevelStackableButtons';

function Skills() {
  const { serviceProviderId, refreshData } = useServiceProvider();
  const navigate = useNavigate();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);

  const config = getConfig({
    apiBaseUrl: getApiUrl(),
    serviceProviderId,
  });

  const onChange = () => {
    refreshData({
      refreshProfileWarnings: true,
    });
  };

  return (
    <ServiceProviderLayout
      selectedStepperId="SKILLS"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <SkillsSetup
        permissionName="SERVICEPROVIDERSKILLS"
        config={config}
        onChange={onChange}
        pageSectionLabel={
          <FormattedMessage
            id="SERVICE_PROVIDER_SKILLS"
            defaultMessage="Service Provider Skills"
          />
        }
      />
    </ServiceProviderLayout>
  );
}

const SkillsObserver = observer(Skills);
export default withServiceProvider(SkillsObserver);
